import React from 'react';
import WelcomeSection from './dashboard/WelcomeSection';
import BrandsSection from './dashboard/BrandsSection';
// import AnalyticsSection from './dashboard/AnalyticsSection'; // Removed - analytics now shown in brand cards only
import AddProjectModal from './dashboard/AddProjectModal';
import NewAffiliatesLive from './dashboard/NewAffiliatesLive';

const MainContentModular = ({ recentlyContactedAffiliates, newAffiliatesByCountry }) => {
  return (
    <main
      className="p-4 min-h-screen bg-gray-100 dark:bg-slate-950 transition-colors duration-300"
      style={{
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }}
    >
      <WelcomeSection />
      <AddProjectModal />
      <NewAffiliatesLive />
      <BrandsSection />
      {/* <AnalyticsSection
        newAffiliatesByCountry={newAffiliatesByCountry}
      /> */}

    </main>
  );
};

export default MainContentModular;